import {
  trackToolExperience,
  deviceLayout,
} from "../../features/toolExperience/telemetry";
import { Link } from "react-router-dom";
import { WorkList } from "../../components/ToolPage";
import { toolDefinitions } from "../../features/tools/registry";
import type { WorkFeedItem } from "./workFeed";
import styles from "./Dashboard.module.css";
export default function ContinueWork({ items }: { items: WorkFeedItem[] }) {
  return (
    <section className={styles.section} aria-labelledby="recent-work-title">
      <div className={styles.sectionHeading}>
        <h2 id="recent-work-title">Continue working</h2>
        <Link to="/tools">All tools</Link>
      </div>
      <WorkList
        onOpen={(key) => {
          const item = items.find((i) => i.key === key);
          if (item)
            trackToolExperience("work_opened", {
              toolId: item.toolId,
              source: "home",
              layout: deviceLayout(),
            });
        }}
        state="ready"
        emptyContent={<p>Choose a tool to start your next task.</p>}
        items={items.slice(0, 5).map((item) => ({
          id: item.key,
          title: item.title,
          href: item.href,
          metadata: [
            {
              label: "",
              value:
                toolDefinitions.find((t) => t.id === item.toolId)?.label ||
                item.toolId,
            },
            ...(item.timestamp
              ? [
                  {
                    label: item.timestampKind,
                    value: new Date(item.timestamp).toLocaleDateString(),
                  },
                ]
              : []),
          ],
          status: {
            label: item.stateLabel,
            tone:
              item.attentionReason === "failed"
                ? "danger"
                : item.stateLabel.toLowerCase().includes("complete")
                  ? "success"
                  : "neutral",
          },
          actions: [],
        }))}
      />
    </section>
  );
}
